/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GachaServiceSearchUserGachaRequest } from '../../models/gacha-service-search-user-gacha-request';
import { SearchUserGachaResponse } from '../../models/search-user-gacha-response';

export interface GachaServiceSearchUserGacha$Params {
  userUuid: string;
      body: GachaServiceSearchUserGachaRequest
}

export function gachaServiceSearchUserGacha(http: HttpClient, rootUrl: string, params: GachaServiceSearchUserGacha$Params, context?: HttpContext): Observable<StrictHttpResponse<SearchUserGachaResponse>> {
  const rb = new RequestBuilder(rootUrl, gachaServiceSearchUserGacha.PATH, 'post');
  if (params) {
    rb.path('userUuid', params.userUuid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SearchUserGachaResponse>;
    })
  );
}

gachaServiceSearchUserGacha.PATH = '/api/v3/gateway/user/{userUuid}/gacha/search';
